import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateSectionMutation = createMutationHook(ShopRendererApiClient.createSection, {
  mutationKey: ['createSection'],
})
